import APIPublicPage from '@/pages/publicPage/APIPublicPage';
import { lazy } from 'react';

const LoginPages = lazy(() => import('../pages/Authpages/login/LoginPage'));
const SignUpPages = lazy(() => import('../pages/Authpages/signup/signup'));
const ForgotPasswordPage = lazy(
  () => import('../pages/Authpages/forgotpassword/VerifyEmail'),
);
const ResetPasswordPage = lazy(
  () => import('../pages/Authpages/forgotpassword/ResetPassword'),
);
const VerifyOtpPage = lazy(
  () => import('../pages/Authpages/verify-otp/VerifyOTP'),
);
const SetPasswordPage = lazy(
  () => import('../pages/Authpages/set-password/SetPassword'),
);
const PublicPage = lazy(() => import('../pages/publicPage/PublicPage'));
const FileDownload = lazy(() => import('../pages/DownloadFile/FileDownload'));

const VkycPublicPage = lazy(() => import('@/pages/vkyc/VkycPublicPage'));

export const AuthRoutes = [
  { index: true, path: '/*', element: <LoginPages /> },
  { path: '/sign-up', element: <SignUpPages /> },
  { path: '/forgot-password', element: <ForgotPasswordPage /> },
  { path: '/reset-password', element: <ResetPasswordPage /> },
  { path: '/verify-otp', element: <VerifyOtpPage /> },
  { path: '/userLink/:id', element: <PublicPage /> },
  { path: '/public-api', element: <APIPublicPage /> },
  { path: '/set-password', element: <SetPasswordPage /> },
  { path: '/userLink/:caseId/check/:checkId', element: <PublicPage /> },
  { path: '/public/files/:keyId', element: <FileDownload /> },
  { path: '/id-verification/:id', element: <VkycPublicPage /> },
];
